import { useInputValidation } from './useInputValidation';

export const usePhoneValidation = (email?: string) => {
  return useInputValidation(email, [
    {
      validation: (v) => v !== undefined && v.replaceAll('-', '').length === 7, // including the dash.
      message: 'Símanúmer er ekki á réttu formi',
    },
  ]);
};
